import { connect } from 'react-redux';
import { selectIsFavourite, updateFavourite } from '@noths/polaris-client-user-favourites';
import getConfig from 'next/config';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectShowFeaturedProduct } from 'src/redux/products/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import { actions as visibilityTrackingActions } from 'src/redux/visibilityTracking';
import type { NextConfig } from 'src/types/nextConfig';
import { FeaturedProduct } from '../components/FeaturedProduct';
import { onProductOutOfStock } from '../modules/actions';
import { FEATURED_PRODUCT_VISIBILITY_NAME } from '../tracking/events';

const nextConfig = getConfig() as NextConfig;

const mapStateToProps = (state: ReduxApplicationState) => ({
  currency: state.products.currencyCode,
  product: state.products.featuredProduct,
  visible: selectShowFeaturedProduct(state),
  isFavorite: state.products.featuredProduct
    ? selectIsFavourite(state.favourites.summary, state.products.featuredProduct.code)
    : false,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onComponentVisible: () =>
    dispatch(
      visibilityTrackingActions.sectionVisible({ sectionName: FEATURED_PRODUCT_VISIBILITY_NAME }),
    ),
  onProductOutOfStock: () => dispatch(onProductOutOfStock()),
  onUpdateFavorite: (productCode: number) => dispatch(updateFavourite({ productCode, nextConfig })),
});

export const FeaturedProductContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FeaturedProduct);
